import { useEffect, useMemo } from "react";
import { registerDismissableLayer } from "./dismissableLayer";

let _id = 0;

export function useDismissableLayer({
  enabled,
  refs,
  onDismiss,
  onEscape,
  closeOnOutside = true,
}) {
  const entry = useMemo(
    () => ({
      id: ++_id,
      enabled: !!enabled,
      refs: refs || [],
      onDismiss,
      onEscape,
      closeOnOutside: closeOnOutside !== false,
    }),
    []
  );

  // keep fields fresh without re-registering
  entry.enabled = !!enabled;
  entry.refs = refs || [];
  entry.onDismiss = onDismiss;
  entry.onEscape = onEscape;
  entry.closeOnOutside = closeOnOutside !== false;

  useEffect(() => {
    if (!enabled) return;
    return registerDismissableLayer(entry);
  }, [enabled, entry]);
}
